/**
 * ContactSection Component
 * 聯繫方式輸入區塊
 * Requirements: 6.1, 6.2
 */

import type { ContactInfo } from '../../types/card';
import type { Translations } from '../../i18n';

interface ContactSectionProps {
  contact: ContactInfo;
  onContactChange: (contact: ContactInfo) => void;
  t: Translations;
}

export function ContactSection({ contact, onContactChange, t }: ContactSectionProps) {
  const handleChange = <K extends keyof ContactInfo>(field: K, value: string) => {
    onContactChange({ ...contact, [field]: value });
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">{t.contactInfo}</h3>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t.telegramId}
          </label>
          <input
            type="text"
            value={contact.tg}
            onChange={(e) => handleChange('tg', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="@mjj_trader"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t.nodeseekId}
          </label>
          <input
            type="text"
            value={contact.ns}
            onChange={(e) => handleChange('ns', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="username"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t.tradingPlatform}
        </label>
        <input
          type="text"
          value={contact.xy}
          onChange={(e) => handleChange('xy', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="https://xianyu.com/..."
        />
      </div>
    </div>
  );
}
